import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';

var _withId = /*#__PURE__*/_withScopeId("data-v-7afc368f");

_pushScopeId("data-v-7afc368f");

var _hoisted_1 = {
  style: {
    "background": "linear-gradient(to bottom right, #409EFF, #409EFF)",
    "height": "100vh"
  }
};
var _hoisted_2 = {
  "class": "bg-bubbles"
};
var _hoisted_3 = {
  "class": "content"
};
var _hoisted_4 = {
  "class": "title"
};
var _hoisted_5 = {
  "class": "main"
};

var _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  alt: "logo",
  "class": "main-logo",
  src: _imports_0
}, null, -1);

var _hoisted_7 = {
  "class": "main-title"
};
var _hoisted_8 = {
  "class": "desc"
};
var _hoisted_9 = {
  key: 0,
  "class": "qrcode"
};
var _hoisted_10 = {
  "class": "footer"
};
var _hoisted_11 = {
  "class": "links"
};

var _hoisted_12 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('远程网联'));

var _hoisted_13 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('米拓科技'));

var _hoisted_14 = {
  "class": "copyright"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_link = _resolveComponent("el-link");

  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("ul", _hoisted_2, [(_openBlock(), _createBlock(_Fragment, null, _renderList(10, function (i) {
    return _createVNode("li", {
      key: i
    });
  }), 64))]), _createVNode("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createVNode("div", _hoisted_5, [_hoisted_6, _createVNode("span", _hoisted_7, _toDisplayString(_ctx.fullTitle), 1)]), _createVNode("div", _hoisted_8, _toDisplayString(_ctx.subTitle), 1)]), _ctx.client && _ctx.client === '桌面端' ? (_openBlock(), _createBlock("div", _hoisted_9)) : _createCommentVNode("", true)]), _createVNode("div", _hoisted_10, [_createVNode("div", _hoisted_11, [_createVNode(_component_el_link, {
    icon: "el-icon-link",
    href: "https://www.qyyiwei.com/"
  }, {
    "default": _withId(function () {
      return [_hoisted_12];
    }),
    _: 1
  }), _createVNode(_component_el_link, {
    icon: "el-icon-link",
    href: "https://www.meatou.com/"
  }, {
    "default": _withId(function () {
      return [_hoisted_13];
    }),
    _: 1
  })]), _createVNode("div", _hoisted_14, " Copyright @ " + _toDisplayString(_ctx.copyright), 1)])]);
});